import { neutralFillToggleActiveDelta, neutralFillToggleFocusDelta, neutralFillToggleHoverDelta, neutralPalette, } from "../fast-design-system";
import { colorRecipeFactory, swatchFamilyToSwatchRecipeFactory, SwatchFamilyType, } from "./common";
import { accessibleAlgorithm } from "./accessible-recipe";
/**
 * @internal
 */
export const neutralFillToggle = colorRecipeFactory(accessibleAlgorithm(neutralPalette, 4.5, 0, neutralFillToggleHoverDelta, neutralFillToggleActiveDelta, neutralFillToggleFocusDelta));
/**
 * @internal
 */
export const neutralFillToggleRest = swatchFamilyToSwatchRecipeFactory(SwatchFamilyType.rest, neutralFillToggle);
/**
 * @internal
 */
export const neutralFillToggleHover = swatchFamilyToSwatchRecipeFactory(SwatchFamilyType.hover, neutralFillToggle);
/**
 * @internal
 */
export const neutralFillToggleActive = swatchFamilyToSwatchRecipeFactory(SwatchFamilyType.active, neutralFillToggle);
/**
 * @internal
 */
export const neutralFillToggleFocus = swatchFamilyToSwatchRecipeFactory(SwatchFamilyType.focus, neutralFillToggle);
